module.exports = __webpack_public_path__ + "media/img/medidok-logo-0ca3e9a811f9f908435e699f53a622c4.jpg";